export const PDF_COLORS = {
  primary: [22, 88, 255] as [number, number, number],
  secondary: [41, 160, 158] as [number, number, number],
  accent: [253, 140, 4] as [number, number, number],
  success: [34, 197, 94] as [number, number, number],
  warning: [245, 158, 11] as [number, number, number],
  error: [239, 68, 68] as [number, number, number],
  border: [229, 231, 235] as [number, number, number],
  text: {
    primary: [31, 41, 55] as [number, number, number],
    secondary: [75, 85, 99] as [number, number, number],
    light: [156, 163, 175] as [number, number, number],
    white: [255, 255, 255] as [number, number, number],
    black: [0, 0, 0] as [number, number, number]
  },
  background: {
    light: [249, 250, 251] as [number, number, number],
    white: [255, 255, 255] as [number, number, number],
    primary: [238, 245, 255] as [number, number, number]
  }
};

export const getStatusColor = (status: 'Ready' | 'Almost Ready' | 'Not Ready'): [number, number, number] => {
  switch(status) {
    case 'Ready': return PDF_COLORS.success;
    case 'Almost Ready': return PDF_COLORS.warning;
    case 'Not Ready': return PDF_COLORS.error;
    default: return PDF_COLORS.text.secondary;
  }
};

export const getScoreColor = (percentage: number): [number, number, number] => {
  if (percentage >= 80) return PDF_COLORS.success;
  if (percentage >= 60) return PDF_COLORS.warning;
  return PDF_COLORS.error;
};